import { z } from 'zod'
import { productEnum, productionTechnologyEnum, type Product } from '../../schemas/catalog/production-technology'
import type { MarketCommunicationStatus } from '../../schemas/record/market-communication-status'
import { OfferStatus } from '../../schemas/record/offer-status'
import type { OfferEntity } from '../../schemas/record/offer-entity.schema'

export interface OfferPortfolioEntity {
  contractNumber: string
  product?: Product
  counterpartyName?: string
  locationNameCustomer?: string
  productionTechnology?: string
  location?: string
  totalInstalledCapacity?: number
  contractStartDate?: string
  contractEndDate?: string
  status?: OfferStatus
  marketCommunicationStatus?: MarketCommunicationStatus
  createdAt: string
  updatedAt: string
  contactPersonEnbw?: string
}

/** an offer as listed for its company, so only record level columns and no section data */
export type CompanyOffer = Pick<
  OfferEntity,
  'contractNumber' | 'product' | 'productionTechnology' | 'status' | 'marketCommunication' | 'createdAt' | 'updatedAt'
>

// whether a single section may still be changed is a product decision - ask
// definitionFor(record.product).isSectionEditable(record.status, section) instead

export const GenerateContractNumberRequest = z.object({
  productionTechnology: productionTechnologyEnum,
  product: productEnum,
})

export type GenerateContractNumberRequest = z.infer<typeof GenerateContractNumberRequest>

export const MarketRegisterDataRequest = z.object({
  technology: productionTechnologyEnum.transform((val) => (val === 'Wind Onshore' ? 'Wind' : val)),
  marketRegisterNumber: z.string(),
})

export const CompanyDataRequest = z.object({
  registrationType: z.string().trim().min(1),
  registrationAuthorityName: z.string().trim().min(1),
  registrationNumber: z.string().trim().min(1),
})

// request body schema for the offer patch endpoint (saves one section of an incomplete offer).
// Which sections exist is a product decision, so the handler resolves the name, not this schema.
export const PatchOfferRequest = z.object({
  contractNumber: z.string().min(1),
  section: z.string().min(1),
  data: z.looseObject({}),
})

export type PatchOfferRequest = z.infer<typeof PatchOfferRequest>

export const ConfirmSupplyRequestSchema = z.object({
  directMarketingDate: z.iso.date().transform((date) => new Date(`${date}T00:00:00.000Z`)),
})

export const EndSupplyRequestSchema = z.object({
  endSupplyDate: z.iso.date().transform((date) => new Date(`${date}T00:00:00.000Z`)),
})
